import React, { lazy, Suspense, useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.scss';
import Intro from '../src/components/intro.js';
import ProjectItem from '../src/components/projectItem';
import Pricing from '../src/components/pricing.js';
import { client } from './sanityClient';

const ProjectDetail = lazy(() => import('../src/components/projectDetail.js'));

function App() {
  const [projects, setProjects] = useState([]);
  const [siteSettings, setSiteSettings] = useState(null);
  const [pricingTiers, setPricingTiers] = useState([]);

  useEffect(() => {
    client.fetch(`*[_type == "project"] | order(column asc, order asc)`)
      .then(setProjects);
    client.fetch(`*[_type == "siteSettings"][0]`)
      .then(setSiteSettings);
    client.fetch(`*[_type == "pricingTier"] | order(order asc)`)
      .then(setPricingTiers);
  }, []);

  return (
    <Router>
      <header className="App-header d-flex align-items-lg-center justify-content-between">
        <div className="logo d-flex justify-self-start">smørre</div>
        <div className="status-pill d-flex align-items-center">
          <span className="d-block green"></span>Available <span className="d-none d-sm-block ps-1">for projects</span>
        </div>
        <nav>
          <ul className="links-container d-flex p-0 m-0 flex-column flex-lg-row">
            {siteSettings?.socialLinks?.dribbble && (
              <li className="links-item"><a target="blank_" href={siteSettings.socialLinks.dribbble} className="link active">Dribbble</a></li>
            )}
            {siteSettings?.socialLinks?.linkedin && (
              <li className="links-item"><a target="blank_" href={siteSettings.socialLinks.linkedin} className="link">LinkedIn</a></li>
            )}
            {siteSettings?.socialLinks?.twitter && (
              <li className="links-item"><a target="blank_" href={siteSettings.socialLinks.twitter} className="link">X</a></li>
            )}
            {siteSettings?.socialLinks?.instagram && (
              <li className="links-item"><a target="blank_" href={siteSettings.socialLinks.instagram} className="link">Instagram</a></li>
            )}
          </ul>
        </nav>
      </header>
      <section className="App p-0">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Intro siteSettings={siteSettings} />
                <div className="projects-container">
                  {projects.map((project) => (
                    <ProjectItem key={project._id} project={project} />
                  ))}
                </div>
                <Pricing tiers={pricingTiers} />
              </>
            }
          />
          <Route
            path="/project/:projectId"
            element={
              <Suspense fallback={null}>
                <ProjectDetail projects={projects} />
              </Suspense>
            }
          />
        </Routes>
      </section>
      <footer>
        <a href={`mailto:${siteSettings?.email || 'jonni@smorre.is'}`} className="d-block">
          <h1>Let's chat</h1>
          <h1>{siteSettings?.email ? siteSettings.email.toUpperCase() : 'HI@SMORRE.IS'}</h1>
        </a>
        <span>2024</span>
      </footer>
    </Router>
  );
}

export default App;
